import { BasePropertyApi } from './base-api.interface';
import { getTextAlignment } from './get-common-properties';
import { updateTextAlignment } from './update-common-properties';

export const textAlignmentAPI: BasePropertyApi = {
  get: getTextAlignment,
  update: updateTextAlignment,
};
